import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

// Authenticated property routes, mounted under the AppLayout shell.
// - PROPERTIES       : the seller's promoted properties + portfolio status
// - PROPERTY_DETAIL  : one property's status, facts, settlement and documents
//
// There is no create route: a seller cannot create a property. Properties exist
// only because an admin promoted an approved, signed sell request.
export const propertyRoutes: RouteRecordRaw[] = [
  {
    path: routes.PROPERTIES,
    name: 'PROPERTIES',
    component: () => import('./PropertiesListPage.vue'),
    meta: {
      requiresAuth: true,
      title: 'Properties',
      subtitle: 'Track your properties from setup to settlement.',
    },
  },
  {
    path: routes.PROPERTY_DETAIL,
    name: 'PROPERTY_DETAIL',
    component: () => import('./PropertyDetailPage.vue'),
    meta: {
      requiresAuth: true,
      title: 'Property Details',
      subtitle: 'Property details and settlement for this property.',
    },
  },
]
